import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '@/api/client';
import { Badge } from './ui/badge';

interface InstanceLite {
  id: string;
  status: string;
}

// Summary badge for the sidebar footer. Shows "X / Y connected" where X is
// the count of currently-connected numbers and Y is the total paired. Goes
// red if zero connected, amber if some pending pair, green if all up.
export function ConnectionBadge() {
  const { data } = useQuery({
    queryKey: ['whatsapp-instances'],
    queryFn: () => api.get<{ instances: InstanceLite[] }>('/api/whatsapp'),
    refetchInterval: 15_000,
  });

  const total = data?.instances?.length ?? 0;
  const connected = data?.instances?.filter((i) => i.status === 'connected').length ?? 0;
  const pending =
    data?.instances?.filter((i) => i.status === 'qr_pending' || i.status === 'connecting').length ??
    0;

  const variant: 'success' | 'warning' | 'destructive' =
    connected > 0 ? 'success' : pending > 0 ? 'warning' : 'destructive';
  const dotColor =
    connected > 0
      ? 'bg-emerald-500'
      : pending > 0
        ? 'bg-amber-500'
        : 'bg-destructive';

  const label = total === 0 ? 'Not paired' : `${connected}/${total} connected`;

  return (
    <Link to="/whatsapp" className="inline-flex items-center gap-2 hover:opacity-90">
      <span className={`inline-block h-2 w-2 rounded-full ${dotColor}`} />
      <Badge variant={variant as any}>{label}</Badge>
    </Link>
  );
}
